import React from 'react';

// Import Badge and Card from @coupling/ui so the alias resolution works for all sites
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Badge, Card } from '@coupling/ui';

const points = [
  {
    title: 'Built on Stripe',
    body: 'Card payments, payouts, and refunds run through our Stripe integration, connected to your Coupling catalog, checkout, and rewards.',
  },
  {
    title: 'Tap to Pay, nothing extra',
    body: 'Take contactless cards on the iPhone or Android you already carry. No extra device needed to get started.',
  },
  {
    title: 'Or an optional Stripe reader',
    body: 'Add a countertop or handheld Stripe Terminal reader when you want one. It works through Coupling POS, so sales, tips, and rewards stay in one place.',
  },
];

/**
 * Stripe integration + hardware message, shared by the homepage and the Pricing page.
 */
export const StripePaymentsSection: React.FC<{
  id?: string;
  heading?: string;
  className?: string;
  hardwareFraming: string;
}> = ({
  id = 'payments-hardware',
  heading = 'Payments & hardware',
  className = 'bg-white',
  hardwareFraming,
}) => (
  <section id={id} className={`px-4 py-20 ${className}`}>
    <div className="mx-auto max-w-6xl">
      <div className="mx-auto mb-10 max-w-3xl text-center">
        <Badge variant="primary" size="md">Powered by Stripe</Badge>
        <h2 className="mt-4 font-display text-3xl font-bold text-neutral-900 sm:text-4xl">{heading}</h2>
        <p className="mt-4 text-lg text-neutral-600">{hardwareFraming}</p>
      </div>
      <div className="grid gap-6 md:grid-cols-3">
        {points.map((p) => (
          <Card key={p.title} padding="md">
            <h3 className="font-display text-lg font-semibold text-neutral-900">{p.title}</h3>
            <p className="mt-2 text-neutral-600">{p.body}</p>
          </Card>
        ))}
      </div>
      <p className="mt-8 text-center">
        <a href="/hardware" className="font-semibold text-brand-primary underline-offset-2 hover:underline">
          See the Stripe readers available through Coupling →
        </a>
      </p>
    </div>
  </section>
);

export default StripePaymentsSection;
